<template>
    <div class="state-selector-tooltip" v-if="showSelector && !isRestricted">
        <div class="oplist-top-bar py-2 clearfix" v-cloak>

            <div class="float-left col-6 col-md-10 px-0 font-weight-bold text-uppercase">
                <img class="nav-flag float-left mr-2 mt-1 lazyload" width="20" height="20"
                    :data-src="flags[localGeo][currentState]">
                <span v-html="regionName" class="localName"></span>
                <span v-if="!sideBar" class="d-none d-md-inline mr-2">, {{ geoName }}</span>

                <div v-if="emptyList && regionHomepageLink && showOfferAlert"
                     class="oplitstTooltip d-none d-md-inline-block">
                    <svg class="tooltipInfo mr-1" xmlns="http://www.w3.org/2000/svg"
                         aria-hidden="true" role="img" width="20" height="20"
                         preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
                        <path
                            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-1 4.705c-.07.34.029.533.304.533c.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598c-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081l.082-.381l2.29-.287zM8 5.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2z"/>
                    </svg>
                    <span> Online gambling is not available in this state. More information is available<a
                        :href="regionHomepageLink" class="moreInfo"> here</a></span>
                    <svg class="ml-1 closeTooltip" xmlns="http://www.w3.org/2000/svg"
                         aria-hidden="true" role="img" width="20" height="20"
                         preserveAspectRatio="xMidYMid meet" viewBox="0 0 50 50">
                        <path d="M37.304 11.282l1.414 1.414l-26.022 26.02l-1.414-1.413z" fill="#777"/>
                        <path d="M12.696 11.282l26.022 26.02l-1.414 1.415l-26.022-26.02z" fill="#777"/>
                    </svg>
                </div>

                <div v-if="offerState && !sideBar && showOfferAlert" class="d-none d-md-inline">
                    <div v-if="noOfferAlert" class="oplitstTooltip"
                         v-on:click="noOfferAlert=false;noOfferAlertDisable=true">
                        <svg class="tooltipInfo mr-1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="20"
                             height="20" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
                            <path
                                d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-1 4.705c-.07.34.029.533.304.533c.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598c-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081l.082-.381l2.29-.287zM8 5.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2z"/>
                        </svg>
                        <span v-if="stateDefault"> No Offers in
                            <span class="cityName" v-html="regionName"></span>.
                        </span>
                        Showing Offers in <span class="cityName" v-html="offerStateName"></span>
                        <svg class="ml-1 closeTooltip" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="20"
                             height="20" preserveAspectRatio="xMidYMid meet" viewBox="0 0 50 50">
                            <path d="M37.304 11.282l1.414 1.414l-26.022 26.02l-1.414-1.413z" fill="#777"/>
                            <path d="M12.696 11.282l26.022 26.02l-1.414 1.415l-26.022-26.02z" fill="#777"/>
                        </svg>
                    </div>
                </div>


                <div v-if="noOfferAlertDisable && showOfferAlert" class="oplitstTooltipDisable d-none d-md-inline "
                     :class="{ 'd-md-none' : sideBar === false }">
                    <svg class="tooltipInfoDisable" v-on:click="noOfferAlert=true; noOfferAlertDisable=false;"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         aria-hidden="true" role="img" width="20" height="20" preserveAspectRatio="xMidYMid meet"
                         viewBox="0 0 16 16">
                        <path
                            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-1 4.705c-.07.34.029.533.304.533c.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598c-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081l.082-.381l2.29-.287zM8 5.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2z"/>
                    </svg>
                </div>
            </div>

            <div class="float-right text-right col-6 col-md-2 px-0">
                <div v-if="noOfferAlertDisable && !sideBar" class="oplitstTooltipDisable d-md-none">
                    <svg class="tooltipInfoDisable" v-on:click="noOfferAlert=true; noOfferAlertDisable=false;"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         aria-hidden="true" role="img" width="20" height="20" preserveAspectRatio="xMidYMid meet"
                         viewBox="0 0 16 16">
                        <path
                            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-1 4.705c-.07.34.029.533.304.533c.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598c-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081l.082-.381l2.29-.287zM8 5.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2z"/>
                    </svg>
                </div>

                <a :href="'#stateSelectorModal-' + id" class="blue-text" data-toggle="modal">
                    <img class="lazyload" width="12" height="15" data-src="https://objects.kaxmedia.com/auto/o/139709/196fe493bb.svg"
                        alt="Blue Location Icon">
                    <span class="m-0 font-weight-bold text-uppercase localName">EDIT LOCATION</span>
                </a>

                <div class="modal state-selector" :id="'stateSelectorModal-' + id" tabindex="-1" role="dialog"
                     aria-labelledby="slotModalLabel" aria-hidden="true">
                    <div class="modal-container">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header flex-row-reverse">
                                    <button type="button" class="close font-weight-bold text-uppercase"
                                            data-dismiss="modal" aria-label="Close">
                                        close <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class='modal-body'>
                                    <div class="font-weight-bold text-uppercase mb-1 mx-1 text-left">locale:</div>

                                    <div class="grey-background">
                                        <select :id="'state-select-' + id" class="select2 state-select op-list-select"
                                                data-width="100%">
                                            <option></option>
                                            <option v-for="state in stateData" :key="state.code" :value="state.code"
                                                    v-html="state.name" data-gtm="state-selector-oplist"></option>
                                        </select>
                                    </div>

                                    <button @click="changeRegion" type="button" data-dismiss="modal"
                                            class="update-state" style="display: none;">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-on:click="noOfferAlert=false;noOfferAlertDisable=true" v-if="noOfferAlert && offerState"
             class="row align-items-center no-gutters oplitstTooltipSmall" :class="{ 'd-md-none' : sideBar === false }">
            <div class="col-auto">
                <svg class="tooltipInfo mr-1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="20" height="20"
                     preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
                    <g fill="#333333">
                        <path
                            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-1 4.705c-.07.34.029.533.304.533c.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598c-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081l.082-.381l2.29-.287zM8 5.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2z"/>
                    </g>
                </svg>
            </div>
            <div class="col pl-1">
                <span v-if="stateDefault">No Offers in <span class="cityName" v-html="regionName"></span>. </span>Showing
                Offers in <span class="cityName" v-html="offerStateName"></span>
            </div>
            <div class="col-auto">
                <svg class="ml-1 closeTooltip" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="20" height="20"
                     preserveAspectRatio="xMidYMid meet" viewBox="0 0 50 50">
                    <path d="M37.304 11.282l1.414 1.414l-26.022 26.02l-1.414-1.413z" fill="#777"/>
                    <path d="M12.696 11.282l26.022 26.02l-1.414 1.415l-26.022-26.02z" fill="#777"/>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'region-selector',
    props: {
        showOfferAlert: {
            type: Boolean,
            default: true,
        },
        rankId: {
            type: Number,
            required: false,
        },
        defaultGeo: {
            type: String,
            required: true,
        },
        regionData: {
            type: Object,
            required: true,
        },
        sideBar: {
            type: Boolean,
            required: false,
            default: false,
        },
        emptyList: {
            type: Boolean,
            default: false,
        },
        regionHomepageLink: {
            type: String,
        },
        offerState: {
            type: String,
            required: false,
        },
        stateDefault: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            id: Math.floor(Math.random() * 100000),
            geoName: '',
            localGeo: this.defaultGeo,
            stateData: [],
            regionName: '',
            currentState: '',
            selectedStateName: '',
            flags: window.flags,
            noOfferAlert: true,
            noOfferAlertDisable: false,
            alert: true,
            alertDisable: false,
            showSelector: false,
            offerStateName: '',
            ipCountry: $('html').attr('data-ipcountry')
                ? $('html').attr('data-ipcountry').toUpperCase()
                : this.defaultGeo,
            regionCode: $('html').attr('data-regioncode')
                ? $('html').attr('data-regioncode').toUpperCase()
                : this.currentState,
        }
    },
    beforeMount: function () {
        // Remove ON from selector for Non ON users
        if (this.regionCode != "ON") {
            this.regionData['CA'].supported_regions = this.regionData['CA'].supported_regions.filter(item => item.code !== "ON")
        }

        this.setDefaultState(this.defaultGeo)
        this.setStateData(this.defaultGeo)
    },
    mounted: function () {
        let region = this.currentState

        if ($cookies.isKey(('op_list_region_' + this.defaultGeo.toLowerCase()))) {
            region = $cookies.get(('op_list_region_' + this.defaultGeo.toLowerCase()))
            this.setStateData(this.defaultGeo)
        } else if ($cookies.isKey('op_list_region')) {
            //Need this to handle current CA cookie
            region = $cookies.get('op_list_region')
            this.setStateData(this.defaultGeo)
        }

        this.regionName = this.stateData.filter(state => {
            return state.code == region;
        })[0].name;

        if (this.offerState) {
            this.offerStateName = this.stateData.filter(state => {
                return state.code == this.offerState;
            })[0].name;
        }

        this.setDropdownSelectedOption(region);
        this.currentState = region;

        // Initialise the actual dropdown of the region selector
        // This used to be in select2-factory.js but the timeout of 200ms doesn't suit globally so calling the create function in here makes more sense
        if(typeof select2Factory.create === "function") {
            select2Factory.create();
        }
    },
    computed: {
        isRestricted() {
            return this.ipCountry == 'CA' && this.regionCode == 'ON';
        },
    },
    methods: {
        changeRegion() {
            const urlParams = new URLSearchParams(window.location.search)
            const newRegion = document.getElementById('state-select-' + this.id).value

            $cookies.set('op_list_region_' + this.localGeo.toLowerCase(), newRegion)

            // to be removed when CloudFlare is working for US
            if (this.defaultGeo == "US") {
                $cookies.set('op_list_state', newRegion);
            }

            urlParams.set('regionCode', newRegion)
            urlParams.set('country', this.localGeo.toLowerCase())
            window.location.search = urlParams
        },
        setDropdownSelectedOption(state) {
            setTimeout(() => {
                if (document.getElementById('state-select-' + this.id)) {
                    document.getElementById('state-select-' + this.id).value = state;
                    document.getElementById('state-select-' + this.id).dispatchEvent(new Event('change'));
                }
            }, 1000);
        },
        setStateData(geo) {
            this.localGeo = geo
            this.showSelector = window.flags[geo] ? true : false
            window.geoFlags = window.flags[geo]
            this.geoName = this.regionData[geo].region_name
            this.stateData = this.regionData[geo].supported_regions
        },
        setDefaultState(region) {
            this.currentState = this.regionData[region].default_region
        }
    },
    watch: {
        offerState() {
            this.offerStateName = this.stateData.filter(state => {
                return state.code == this.offerState;
            })[0].name;
        }
    },
}
</script>
